import React, { useEffect, useState } from 'react'
import PageHeaderComponent from '../shared/page-header.component'
import GridComponent from '../shared/grid';
import { ColDef, ColumnApi, GridApi, ICellRendererParams, ValueGetterParams } from 'ag-grid-community';
import { ActionLabels, GridStatusLabelVariant, ToasterTexts, appLabels, appNote, buttonLabels, emptyLabels } from '../shared/constants';
import { ActionsRenderer } from '../shared/grid/actionsRenderer';
import { AddUserIcon, CancelIcon, EditIcon, LockIcon, ReInviteIcon, TrashIcon } from '../../icon';
import { useDispatch } from 'react-redux';
import { LoadChannelUsers } from '../../actions';
import { setHeaderCount, setHeaderTitle, setRefreshHandler } from '../../helpers/header.helper';
import { useSelector } from 'react-redux';
import { ChannelPlanModel, ChannelPlanStatus, ChannelUserModel, ChannelUserStatus } from '../../models/users.model';
import * as selector from '../../selectors/selectors';
import { StatusRenderer } from '../shared/grid/statusRenderer';
import { UtilityService } from '../../services/UtilityService';
import { dateComparator } from '../shared/grid/grid.services';
import Confirm_Dialog from '../shared/confirm-dialog.component';
import { ChannelUserService } from '../../services/ChannelUserService';
import ChannelInviteUser from './channel-invite-user.component';
import setToast from '../../helpers/toaster.helper';
import { ToasterType } from '../shared/toaster/toaster.model';
import { Role } from '../../models/roles.model';
import { Dialog, DialogContent, DialogTitle, Tooltip } from '@mui/material';
import { MenuItemRenderer } from '../shared/grid/actionsMenuItemRendrer';
import PullToRefresh from 'react-simple-pull-to-refresh';
import UpgradePlanInfoComponent from '../channel-plans/upgrade-plan-info.component';

const ChannelUsers = () => {
    const dispatch = useDispatch()
    const ChannelUsers: ChannelUserModel[] = useSelector(selector.ChannelUsers)
    const CurrentUser: ChannelUserModel = ChannelUserService.getCurrentUserFromLocalStorage();
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice);
    const PlanDetails: ChannelPlanModel = useSelector(selector.PlanDetails);

    const [gridApi, setGridApi] = useState<GridApi>(null);
    const [columnApi, setColumnApi] = useState<ColumnApi>(null)
    const [buttonName, setButtonName] = useState<string>("");
    const [showConfirmDialog, setShowConfirmDialog] = useState<boolean>(false);
    const [selectedUser, setSelectedUser] = useState<ChannelUserModel>();
    const [showAddUser, setShowAddUser] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [confirmDialogText, setConfirmDialogText] = useState<string>("")
    const [ClickRowData, setClickRowData] = useState<ChannelUserModel | null>(null)
    const [MobileMenu, setMobileMenu] = useState<boolean>(false)
    const [showUpgradePlan, setShowUpgradePlan] = useState<boolean>(false)


    const UsersColoumnDefs: ColDef[] = [
        {
            field: "FirstName",
            headerName: "FirstName",
            valueGetter: (params: ValueGetterParams) => {
                return IsMobileDevice ? `${params.data.FirstName + " " + params.data.LastName}` : params.data.FirstName
            },
            cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },
        },
        {
            field: "LastName",
            headerName: "LastName",
            hide: IsMobileDevice,
        },
        {
            field: "Email",
            headerName: "Email",
            hide: false,
            cellRenderer: params =>
                <span onClick={(e) => e.stopPropagation()} className={`color-grid-link c-pointer ph-no-capture`} >
                    <a href={`mailto:${params.data.Email || ''}`}>{params.data.Email || ''}</a>
                </span>,
            cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },
        },
        {
            field: "RoleID",
            headerName: "Role",
            valueGetter: (params: ValueGetterParams) => {
                return params.data.RoleID === 1 ? "System Admin" : params.data.RoleID === 2 ? "Organization Admin" : params.data.RoleID === 3 ? "Agent" : "Manager"
            },
            hide: false,
            cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },
        },
        {
            field: "UserStatus",
            headerName: "Status",
            hide: false,
            cellRendererSelector: (params: ICellRendererParams) => {
                if (params.data) {
                    const label = params.data.UserStatus === ChannelUserStatus.ACTIVE ? "Active" : params.data.UserStatus === ChannelUserStatus.INACTIVE ? "Inactive" : params.data.UserStatus === ChannelUserStatus.PENDING ? "Pending" : params.data.UserStatus === ChannelUserStatus.DELETED ? "Deleted" : "Disabled";
                    const variant = params.data.UserStatus === ChannelUserStatus.ACTIVE ? GridStatusLabelVariant.Active : params.data.UserStatus === ChannelUserStatus.INACTIVE ? GridStatusLabelVariant.Danger : params.data.UserStatus === ChannelUserStatus.PENDING ? GridStatusLabelVariant.Warning : params.data.UserStatus === ChannelUserStatus.DISABLED ? GridStatusLabelVariant.Danger : GridStatusLabelVariant.Info;
                    const Status = {
                        component: StatusRenderer,
                        params: {
                            Variant: variant, Label: label, Id: params.data.ID, ClassName: "min-h-3 d-flex align-center justify-center w-10"
                        }
                    }
                    return Status
                }
                return undefined
            },
            cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },
        },
        {
            field: "CreatedDateTime",
            headerName: "Created Time",
            hide: IsMobileDevice,
            valueGetter: (params: ValueGetterParams) => UtilityService.convertDateToDay(params.data.CreatedDateTime).toString(),
            cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },
        },
        {
            field: "UpdatedDateTime",
            headerName: "Updated Time",
            valueGetter: (params: ValueGetterParams) => UtilityService.convertDateToDay(params.data.UpdatedDateTime).toString(),
            hide: IsMobileDevice,
            sort: 'desc',
            comparator: (valueA, valueB, nodeA, nodeB) => dateComparator(nodeA.data.UpdatedDateTime, nodeB.data.UpdatedDateTime),
            cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },
            suppressSizeToFit: true,
        },
        {
            field: "Action",
            maxWidth: 40,
            headerName: "",
            pinned: "right",
            lockPinned: true,
            lockPosition: "right",
            cellClass: "ag-cell-actions-style",
            headerClass: "bg-color-secondary",
            cellRenderer: params => <ActionsRenderer MenuData={getMenuActions(params.data)}
                {...params}
            />,
            resizable: false,
            sortable: false,
            hide: IsMobileDevice
        },
    ]

    const getMenuActions = (data: ChannelUserModel) => {
        return [
            {
                Name: ActionLabels.EDIT,
                Icon: EditIcon,
                OnClick: () => openAdduser(data),
                Hide: (CurrentUser.RoleID === Role.ORGANIZATION_ADMIN && data.UserStatus === Role.ORGANIZATION_ADMIN) ? false : (CurrentUser.RoleID === data.RoleID && CurrentUser.ID !== data.ID)
            },
            {
                Name: ActionLabels.REINVITE,
                Icon: ReInviteIcon,
                OnClick: () => openConfirmDialog(ActionLabels.REINVITE, appNote.RE_INVITE_USER, data),
                Hide: data.UserStatus !== ChannelUserStatus.PENDING
            },
            {
                Name: data?.UserStatus === ChannelUserStatus.ACTIVE ? ActionLabels.DISABLE : ActionLabels.ENABLE,
                Icon: LockIcon,
                OnClick: () => openConfirmDialog(data.UserStatus === ChannelUserStatus.ACTIVE ? ActionLabels.DISABLE : ActionLabels.ENABLE, data?.UserStatus === ChannelUserStatus.DISABLED ? appNote.ENABLE_USER : appNote.DISABLE_USER, data),
                Hide: (CurrentUser.RoleID === Role.ORGANIZATION_ADMIN && data.UserStatus !== ChannelUserStatus.PENDING && CurrentUser.ID !== data.ID && data.RoleID !== Role.ORGANIZATION_ADMIN) ? false : (CurrentUser.ID === data.ID || CurrentUser.RoleID === data.RoleID || data.UserStatus === ChannelUserStatus.PENDING)
            },
            {
                Name: ActionLabels.DELETE,
                Icon: TrashIcon,
                OnClick: () => openConfirmDialog(ActionLabels.DELETE, appNote.DELETE_USER, data),
                Hide: ((CurrentUser.ID === data?.ID))
            }
        ]
    }

    const openAdduser = (data?: ChannelUserModel) => {
        let users = ChannelUsers?.filter(x => x.UserStatus !== ChannelUserStatus.DELETED)
        let Agents = PlanDetails.FeatureKeys?.find(x => x.includes("agent"))?.split("-")[0] || 0
        let planSupportMoreAgents = Number(Agents) * PlanDetails.Quantity > users.length

        if (PlanDetails.Status === ChannelPlanStatus.INACTIVE) {
            setShowUpgradePlan(true)
        }
        else if (Agents === "unlimited" || planSupportMoreAgents || !!data) {
            setShowAddUser(true)
            setSelectedUser(data)
        }
        else {
            setShowUpgradePlan(true)
        }

    }

    const closeAdduser = () => {
        setShowAddUser(false)
        setSelectedUser(undefined)
    }

    const openConfirmDialog = (buttonname: string, text: string, data: ChannelUserModel) => {
        setButtonName(buttonname);
        setShowConfirmDialog(true);
        setSelectedUser(data);
        setConfirmDialogText(text);
    }

    const closeConfirmDialog = (confirm?: boolean) => {
        if (confirm) {
            setIsLoading(true)
            if (buttonName === ActionLabels.REINVITE) {
                const obj = {
                    "fName": selectedUser.FirstName,
                    "lName": selectedUser.LastName,
                    "email": selectedUser.Email.trim(),
                    "role": selectedUser.RoleID,
                    "admin_id": ChannelUserService.getCurrentUserFromLocalStorage()?.ID,
                }
                ChannelUserService.sendInvitation(obj)
                    .then(() => {
                        setIsLoading(false)
                        setToast(ToasterTexts.REINVITE_MESSAGE, ToasterType.SUCCESS)
                        resetState()
                        LoadChannelUsers(dispatch);
                    })
                    .catch((err) => {
                        setToast(err.response.data.message, ToasterType.DANGER)
                        resetState()
                        setIsLoading(false)
                    });

            }
            else if (buttonName === ActionLabels.DELETE) {
                ChannelUserService.deleteUser(selectedUser.ID, CurrentUser.ID).then((res) => {
                    resetState()
                    LoadChannelUsers(dispatch)
                    setToast(ToasterTexts.USER_EDIT_SUCCESS.replace('<Name>', selectedUser.FullName), ToasterType.SUCCESS)
                }).catch((err) => {
                    resetState()
                    setToast(err?.response?.data, ToasterType.DANGER)
                })
            }
            else {
                ChannelUserService.disableUser(selectedUser.ID).then((res) => {
                    resetState()
                    LoadChannelUsers(dispatch)
                    setToast((selectedUser.UserStatus === ChannelUserStatus.ACTIVE ? ToasterTexts.USER_ENABLE_SUCCESS : ToasterTexts.USER_DISABLE_SUCCESS).replace('<Name>', selectedUser.FullName), ToasterType.SUCCESS)
                }).catch((err) => {
                    resetState()
                })
            }
        }
        else {
            resetState();
        }
    }

    const resetState = () => {
        setButtonName("");
        setShowConfirmDialog(false);
        setSelectedUser(undefined);
        setIsLoading(false)
        setConfirmDialogText("")
    }

    const getUserCount = () => {
        let users = ChannelUsers?.filter(x => x.UserStatus !== ChannelUserStatus.DELETED)
        setHeaderCount(users?.length === 1 ? "1 user" : (!!users?.length ? users?.length : "0") + " users")
    }

    const searchUser = (e: any) => {
        gridApi.setQuickFilter(e.target.value);
    }

    const onGridReady = (params) => {
        setGridApi(params.api);
        setColumnApi(params.columnApi)
    }

    const handleRowClick = (row: ChannelUserModel) => {
        if (IsMobileDevice) {
            setMobileMenu(true);
            setClickRowData(row)
        }
    }

    const CloseMobileMenu = () => {
        setMobileMenu(false);
        setClickRowData(null)
    }

    const pullToRefresh = () => new Promise((resolve) => setTimeout(resolve, 15)).then(() => LoadChannelUsers(dispatch))

    const refreshData = () => {
        if (!!gridApi) {
            gridApi.refreshCells({ force: true })
            gridApi.deselectAll();
        }
        LoadChannelUsers(dispatch)
    }

    useEffect(() => {
        LoadChannelUsers(dispatch)
        setHeaderTitle("My Team")
        setHeaderCount("0 users")
        setRefreshHandler(refreshData)
    }, [])

    useEffect(() => {
        getUserCount()
    }, [ChannelUsers])

    return (
        <>
            <PullToRefresh isPullable={IsMobileDevice} pullingContent='' onRefresh={pullToRefresh}>
                <div className="d-flex flex-direction h-p-100 o-hidden justify-between">
                    {(showAddUser && IsMobileDevice) ?
                        <ChannelInviteUser
                            show={showAddUser}
                            onClose={() => closeAdduser()}
                            User={selectedUser}
                        />
                        :
                        <>
                            <div className='w-p-96 mx-auto'>
                                <PageHeaderComponent
                                    onSearch={searchUser}
                                    PlaceHolder={"Find a user ..."}
                                    Actions={[{
                                        OnClick: () => openAdduser(),
                                        ButtonLabel: buttonLabels.ADD_USER,
                                        Icon: AddUserIcon,
                                        Variant: "primary-btn",

                                    }]}
                                />
                            </div>
                            <div className={`w-p-100 h-p-100 d-flex justify-center align-center  ${IsMobileDevice ? "" : "bg-color-secondary"}`}>
                                <div className="w-p-96 h-p-100 bg-color-side-bar br-3 o-hidden ">
                                    <GridComponent
                                        ColumnDefs={UsersColoumnDefs}
                                        RowData={ChannelUsers?.filter(x => x.UserStatus !== ChannelUserStatus.DELETED)}
                                        OnGridReady={onGridReady}
                                        IsPaginationEnabled={!IsMobileDevice}
                                        EmptyLabel={emptyLabels.USERS}
                                        IsFilterPresent={true}
                                        gridApi={gridApi}
                                        LockVisible={false}
                                        filterOptions={[]}
                                        OnGridRowClick={handleRowClick}
                                    />
                                </div>
                            </div>
                        </>

                    }
                    {showConfirmDialog &&
                        <Confirm_Dialog
                            ButtonName={buttonName}
                            onClose={closeConfirmDialog}
                            Show={showConfirmDialog}
                            Text={confirmDialogText}
                            Loading={isLoading}
                        />
                    }

                    {showAddUser && !IsMobileDevice &&
                        <ChannelInviteUser
                            show={showAddUser}
                            onClose={() => closeAdduser()}
                            User={selectedUser}
                        />
                    }

                    {
                        IsMobileDevice && MobileMenu && ClickRowData !== null &&
                        <Dialog
                            fullWidth
                            onClose={CloseMobileMenu}
                            aria-labelledby="responsive-dialog-title"
                            open={MobileMenu}
                            classes={{ paper: "br-2 dialogue-shadow w-p-70 bg-color-menu-bg" }}
                        >
                            <DialogTitle className="dialog-header pb-1">
                                <div className="h1 color-display-title d-flex" id="customized-dialog-title">
                                    {UtilityService.trimMessage(ClickRowData?.FirstName, 18) + " " + UtilityService.trimMessage(ClickRowData?.LastName, 18)}
                                    <Tooltip title='Close' placement='bottom'>
                                        <span className="ml-auto">
                                            <CancelIcon onClick={(e: any) => { e.stopPropagation(); CloseMobileMenu() }} />
                                        </span>
                                    </Tooltip>
                                </div>
                            </DialogTitle>
                            <DialogContent className={"o-hidden py-1 px-1 "}>
                                <MenuItemRenderer MenuData={getMenuActions(ClickRowData)} OnClick={CloseMobileMenu} />
                            </DialogContent>
                        </Dialog>
                    }

                    {
                        showUpgradePlan && <UpgradePlanInfoComponent show={showUpgradePlan} close={() => { setShowUpgradePlan(false) }} AcessingFeatures={[{ featureName: `${PlanDetails.Status === ChannelPlanStatus.INACTIVE ? "Subscription Required" : "Add More Users"}`, Desc: `${PlanDetails.Status === ChannelPlanStatus.INACTIVE ? "Subscribe to a plan to unlock all features" : "To add more users please upgrade your plan"}` }]} />
                    }
                </div>
            </PullToRefresh>
        </>
    )
}

export default ChannelUsers